import React from 'react';
import './ToolTip.css';
 
export const useToolTip = () => {
    const [tooltipText, setTooltipText] = React.useState<string>("");
    const [position, setPosition] = React.useState<{ x: number, y: number }>({ x: 0, y: 0 });
    const [visible, setVisible] = React.useState<boolean>(false);
 
    const [timeoutId, setTimeoutId] = React.useState<NodeJS.Timeout | null>(null);

    const showTooltip = (text: string, event: React.MouseEvent) => {
        const x = event.clientX;
        const y = event.clientY;
        const id = setTimeout(() => {
            setTooltipText(text);
            setPosition({ x: x - 90, y: y + 10 });
            setVisible(true);
        }, 500);
        setTimeoutId(id);
    }

    const moveTooltip = (event: React.MouseEvent) => {
        if (visible) {
            setPosition({ x: event.clientX - 90, y: event.clientY + 10 });
        }
    }

    const hideTooltip = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        setVisible(false);
    }

    return { tooltipText, position, visible, showTooltip, moveTooltip, hideTooltip };
};